module.exports = "<div class=\"box box-border\"> <div class=box-hd> <h3>Hoe werkt het? ..TBD</h3> </div> <div class=box-bd> <ul class=\"list list-dash\"> <li>Maak hier een verzendlabel aan</li> <li>Geef uw pakket met label aan de Febelco koerier</li> <li>Volg via Track & Trace</li> <li>Binnen 48u geleverd op bestemming</li> </ul> </div> </div>";


//////////////////
// WEBPACK FOOTER
// ./features/account/my-packages/components/how-does-it-work-box.html
// module id = 526
// module chunks = 0